import Collapsable, { CollapsableProps } from './Collapsable'

export type { CollapsableProps }
export default Collapsable
